import { verticalLine, yellowCheck, yellowSelector } from '../../assets/images/login';
import styles from './loginForm.module.css';
const WeAreGlobal = () => {
  return (
    <div className='flex'>
      <div className='flex items-start'>
        <div>
          <div className={styles.weGlobal}>
            <p className=' font-Poppins font-medium'>WE ARE GLOBAL</p>
          </div>
          <div className={`${styles.hereForYou} w-[335px] mt-3 mb-5`}>
            <h3 className=' font-Poppins text-[20px] font-[600] text-darkBlack'>
              Offering Easy, Fast and Secure Business Solutions.
            </h3>
            {/*<p className='text-[16px] font-Poppins text-darkBlack font-[600]'>
              We will provide solutions to the challenges you may face on this journey
              </p> */}
          </div>

          <div className='flex gap-4 min-h-[50px] mt-1'>
            <div className='flex flex-column h-100%'>
              <div>
                <img src={yellowCheck} className='m-auto' alt='alt.png' />
              </div>
              <img src={verticalLine} alt='alt.png' className='h-[50px] mt-2' />
            </div>
            <div className='w-[332px] sm:w-[350px]'>
              <p
                style={{
                  lineHeight: '15.4px',
                }}
                className='text-[#229698] font-Poppins font-medium text-[16px] mb-2'
              >
                Cheaper Business Registration
              </p>
              <p className=' font-Poppins font-normal text-[13px] text-[#212121]'>
                Taking away the complexities and lengthy paperwork so things can be simpler for you
              </p>
            </div>
          </div>

          <div className='flex gap-4 min-h-[60px] mt-1'>
            <div className='flex flex-column h-100%'>
              <div>
                <img src={yellowCheck} className='m-auto' />
              </div>
              <img src={verticalLine} alt='alt.png' className='h-[50px] mt-2' />
            </div>
            <div className='w-[332px] sm:w-[350px]'>
              <p
                style={{
                  lineHeight: '15.4px',
                }}
                className='text-[#229698] font-Poppins font-medium text-[16px] mb-2'
              >
                Easy To Pay Back Loans
              </p>

              <p className=' font-Poppins font-normal text-[13px] text-[#212121]'>
                To Expand And Grow Your Business
              </p>
            </div>
          </div>

          <div className='flex gap-4 min-h-[140px] mt-1'>
            <div className='flex flex-column h-100%'>
              <div>
                <img src={yellowCheck} alt='alt.png' />
              </div>
            </div>
            <div className='w-[332px] sm:w-[350px]'>
              <p
                style={{
                  lineHeight: '15.4px',
                }}
                className='text-[#229698] font-Poppins font-medium text-[16px] mb-2'
              >
                Unique Payment Solutions
              </p>
              <p className=' font-Poppins font-normal text-[13px] text-[#212121]'>
                You no longer have to shout to collect your money.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WeAreGlobal;
